import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';
import { CommonModule, Location } from '@angular/common';
import { ReportService } from '../../services/report.service';
@Component({
  selector: 'app-document-preview-component',
  imports: [PdfJsViewerModule, CommonModule],
  templateUrl: './document-preview-component.html',
  styleUrl: './document-preview-component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [],
})
export class DocumentPreviewComponent implements OnInit {
  reportName: string = '';
  jobId: string | null = null;
  reportId: number | null = null;
  blobUrl: string = '';
  aecomReport: string = '';
  public aecomReportURL: string = '';
  fileId: string = '';
  downloadOverrideUrl: string | null = null;
  relativePath: string = '';
  private downloadedBlob!: Blob;
  isDownloading = false;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private reportService: ReportService,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.reportName = params['reportname'];
      this.aecomReportURL = params['documentUrl'] ? decodeURIComponent(params['documentUrl']) : '';
      this.downloadOverrideUrl = params['downloadOverrideUrl']
        ? decodeURIComponent(params['downloadOverrideUrl'])
        : null;

      this.fileId = params['fileId'] ? params['fileId'] : null;
    });
    console.log('isDownloading', this.isDownloading);

    this.previewDoc(this.fileId);
  }

  downloadDoc() {
    this.isDownloading = true;
    this.cdr.detectChanges();
    console.log('isDownloading', this.isDownloading);

    if (this.downloadOverrideUrl?.trim()) {
      this.reportService.downloadReport('', this.downloadOverrideUrl).subscribe({
        next: (res) => {
          const blob = res.body as Blob;
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = this.reportName + '.docx';
          a.click();
          URL.revokeObjectURL(url);
          this.resetDownloadState();
        },
        error: () => {
          console.error('Download failed');
          this.isDownloading = false;
          this.cdr.detectChanges();
        },
      });

      return;
    }

    if (!this.downloadedBlob) {
      this.isDownloading = false;
      return;
    }

    const url = URL.createObjectURL(this.downloadedBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = this.reportName;
    a.click();
    URL.revokeObjectURL(url);
    this.resetDownloadState();
  }

  private resetDownloadState() {
    setTimeout(() => {
      this.isDownloading = false;
      this.cdr.detectChanges();
    }, 500);
  }

  previewDoc(fileId: string = '') {
    this.reportService.downloadReport(fileId, this.aecomReportURL).subscribe((res) => {
      this.downloadedBlob = res.body as Blob;
      const pdfBlob = new Blob([this.downloadedBlob], { type: 'application/pdf' });
      this.aecomReport = URL.createObjectURL(pdfBlob);
    });
  }

  closePreview() {
    if (this.aecomReport) {
      URL.revokeObjectURL(this.aecomReport);
      this.aecomReport = '';
      this.location.back();
    }
  }
}
